﻿
(function ($, document) {
    $(document).ready(function () {
        function updateMaxCountMessage($textbox) {
            var maxCharacter = $textbox.data('max-character');
            var formatString = $textbox.data('max-character-format') || '{n} characters left';
            var currentNumberOfCharacters = $textbox.val().length;
            var $characterMessage = $textbox.siblings('span.character-message');
            $characterMessage.text(formatString.replace('{n}', maxCharacter - currentNumberOfCharacters));
        }

        $('[data-max-character]').each(function (i, n) {
            var $textbox = $(this);
            var maxCharacter = $textbox.data('max-character');
            $textbox.css('resize', 'none');
            $textbox.wrap('<div class="character-counting"></div>');
            $('<span />').addClass('character-message').insertAfter($textbox);
            updateMaxCountMessage($textbox);
        });

        $(document).on('keyup', '[data-max-character]', function (e) {
            updateMaxCountMessage($(this));
        });

        $(document).on('change', '[data-max-character]', function (e) {
            updateMaxCountMessage($(this));
        });

        $(document).on('keydown', '[data-max-character]', function (e) {
            if (e.keyCode == 8      // Backspace
                || e.keyCode == 9   // Tab
                || e.keyCode == 37  // Left
                || e.keyCode == 38  // Up
                || e.keyCode == 39  // Right
                || e.keyCode == 40  // Left
                || e.keyCode == 46  // Down
            ) {
                return;
            }
            if (e.keyCode == 13) {
                e.preventDefault();
            }
            var $textbox = $(this);
            var maxCharacter = $textbox.data('max-character');
            var currentNumberOfCharacters = $textbox.val().length;
            if (maxCharacter <= currentNumberOfCharacters) {
                e.preventDefault();
                $textbox.val($textbox.val().substring(0, maxCharacter));
            }
        });


        $(document).on('input propertychange', '[data-max-character]', function (e) {
            var $textbox = $(this);
            var maxCharacter = $textbox.data('max-character');
            var currentNumberOfCharacters = $textbox.val().length;
            if (maxCharacter <= currentNumberOfCharacters) {
                $textbox.val($textbox.val().substring(0, maxCharacter));
            }
        });
    });

})(jQuery, document);